import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import CreatableDropdown from 'components/layout/forms/CreatableDropdown';
import { CONTACT_TITLE, useChoiceList } from 'services/offers/offerChoices';
import translations from 'services/translations/translations';

/**
 * The title of a contact person: one of the titles the admins suggest (in the language of the
 * user) or any text typed. The title stays free text, so a title saved before is kept as it
 * is. Changes as a field of the form: { target: { name: 'title', value } }.
 */
const ContactTitleField = ({
  disabled,
  label,
  onChange,
  value,
}: {
  disabled?: boolean;
  label: string;
  onChange: (event: { target: { name: string; value: string } }) => void;
  value: string;
}): JSX.Element => {
  const { t } = useTranslation([translations.offers]);
  // The names of the suggested titles; a title typed before is among them as it is
  const titles = useChoiceList(CONTACT_TITLE).map((choice) => ({
    label: choice.label,
    value: choice.label,
  }));

  return (
    <FormGroup>
      <Label className="label">{label}</Label>
      <CreatableDropdown
        className="text-field search-field"
        disabled={disabled}
        name="title"
        onChange={(option: null | { value: string }) =>
          onChange({ target: { name: 'title', value: option?.value ?? '' } })
        }
        options={titles}
        placeholder={t(`${translations.offers}:Search or type`)}
        required={false}
        value={value ? { label: value, value } : null}
      />
    </FormGroup>
  );
};

export default ContactTitleField;
